import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `CopiaSeguridad/programarCopiaSeguridad`, method: 'POST', body: values, token: token})
}
